import { create } from "zustand";
import secureLocalStorage from "react-secure-storage";
import { api } from "../utils/axios-instance";
import { auth } from "../helper/firebaseClient";
import { waitForAuthReady } from "../utils/waitForAuth";

export const useDepartment = create((set) => ({
  departments: [],
  error: false,
  loading: true,

  setDepartments: (departments) => {
    set({ departments });
  },
  setError: (error) => {
    set({ error });
  },
  setLoading: (loading) => {
    set({ loading });
  },

  listDepartments: async () => {
    set({ loading: true });

    let departmentsData = [];
    try {
      await waitForAuthReady();
      const token = auth.currentUser && (await auth.currentUser.getIdToken());
      if (!token) throw new Error("Missing auth token. Please login again.");

      const response = await api.get(`/dept/listDepts`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      departmentsData = response.data;
      secureLocalStorage.setItem(
        "departments",
        JSON.stringify(departmentsData)
      );
      console.log("DEPARTMENT DATA by Zustand: ", departmentsData);
      
      set({
        departments: departmentsData,
        loading: false,
        error: false,
      });
    } catch (error) {
      const cached = secureLocalStorage.getItem("departments");
            if (cached) {
              try {
                const parsed = JSON.parse(cached);
                set({ departments: parsed, error: error.message, loading: false });
                return;
              } catch (_) {}
            }
      set({
        error: error.message,
        loading: false,
      });
    }
  },
}));
